import { render, staticRenderFns } from "./cpt-dataV-digitalFlop.vue?vue&type=template&id=54c68ecb&scoped=true"
import script from "./cpt-dataV-digitalFlop.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-digitalFlop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c68ecb",
  null
  
)

export default component.exports